import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=5f4d2759&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=js&"
export * from "./merchant.vue?vue&type=script&lang=js&"
import style0 from "./merchant.vue?vue&type=style&index=0&id=5f4d2759&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4d2759",
  null
  
)

export default component.exports